export default __webpack_public_path__ + "static/imgExcesspng-2236bbb1173f37593e52c97bff3a2d34.png";